import React from 'react';
import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import './index.less';

export default function(props: TextAreaProps) {
  return <Input.TextArea className='text_area_input' {...props} />;
};

